/**
 * Block is used on
 *
 * @returns {{getPrevious(): void, slides: [], activeSlide: null, getNext(): void}}
 */
export default () => ({
    slides: [],
    activeSlide: null,

    getNext() {
        let index = this.slides.indexOf(this.activeSlide);
        if(index >= 0 && index <  this.slides.length - 1) {
            this.activeSlide = this.slides[index + 1]
            this.activeSlide.visible = true;
        } else {
            this.activeSlide = this.slides[0]
            this.activeSlide.visible = true;
        }
    },

    getPrevious() {
        let index = this.slides.indexOf(this.activeSlide);
        if(index >= 1 && index < this.slides.length + 1) {
            this.activeSlide = this.slides[index - 1]
            this.activeSlide.visible = true;
        }
    }
})